module.exports = __webpack_public_path__ + "static/chicago-9da6997f45c2702ab612cce8af0efec8.jpg";